import { render, staticRenderFns } from "./StockWarning.vue?vue&type=template&id=65e912e3&"
import script from "./StockWarning.vue?vue&type=script&lang=ts&"
export * from "./StockWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports